import React from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import i18n from "utils/I18n";

import { navigateStack } from "utils/WeChatUtil";

import "./LanguagesSelection.scss"
import { RightArrow } from "component/base/SvgIcons";

const AboutMobile = () => {
  const history = useHistory()
  const aboutNavList = [
    {
      titleKey: "about",
      fullLink: process.env.REACT_APP_ABOUT_APP_LINK,
    },
    {
      titleKey: "sign_up_terms_conditions",
      fullLink: process.env.REACT_APP_TERM_CONDITIONS_LINK,
    },
    {
      titleKey: "sign_up_privacy_policy",
      fullLink: process.env.REACT_APP_PRIVACY_LINK,
    },
    {
      titleKey: "FAQs",
      fullLink: process.env.REACT_APP_FAQS_LINK,
    },
  ]
  return (
    <Container>
      <div className="languages-page-container">
        <div className="field-text">
          {aboutNavList?.map((item) =>
            <div className="lanuage-selection-item" onClick={() => navigateStack({
              history,
              fullLink: item?.fullLink
            })}>
              <div>{i18n.t(item?.titleKey)}</div>
              <RightArrow className="svg-color-g3" style={{ width: "16px", height: "16px" }} />
            </div>
          )}
        </div>
      </div>
    </Container>
  )
}

const mapPropsToState = (state) => ({
});

export default  connect(mapPropsToState)(AboutMobile);